import { Box, Text } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import HomeAnalyticsCharts from "../../../components/student/HomeAnalyticsCharts";
import StudentPortalShell from "../../../components/student/StudentPortalShell";
import { studentPalette } from "../../../constants/studentPalette";
import { studentSurfaces } from "../../../constants/studentThemeSurfaces";
import { getPerformanceAnalyticsRequest } from "../../../modules/students-modules/performance/Actions";
import { hasFetchedOnce } from "../../../utils/fetchFreshness";

const C = {
  bg: studentSurfaces.canvas,
  primary: studentPalette.primary,
  secondary: studentPalette.secondary,
  muted: studentSurfaces.textMuted,
};

const StudentPerformanceAnalytics = () => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.user.userData);
  const performanceData = useSelector((state) => state.performance.analytics);
  const analyticsFetchedAt = useSelector(
    (state) => state.performance.analyticsFetchedAt
  );
  const isLoading = useSelector((state) => state.performance.isLoading);

  useEffect(() => {
    if (!userData?.id || hasFetchedOnce(analyticsFetchedAt)) return;
    dispatch(getPerformanceAnalyticsRequest(userData.id));
  }, [dispatch, userData?.id, analyticsFetchedAt]);

  return (
    <StudentPortalShell>
      <Box
        bg={C.bg}
        minH={{ base: "auto", md: "100vh" }}
        py={{ base: 6, md: 10 }}
        px={{ base: 4, md: 6, lg: 8 }}
        overflowX="hidden"
        w="100%"
        maxW="100%"
        minW={0}
      >
        <Box mb={6} w="full" minW={0}>
          <Text
            fontSize="sm"
            fontWeight="800"
            color={C.secondary}
            letterSpacing="0.08em"
            textTransform="uppercase"
            sx={{ "html[data-theme='dark'] &": { color: "var(--text-muted)" } }}
          >
            Performance Analytics
          </Text>
          <Text fontSize="sm" color={C.muted} mt={1}>
            Track your accuracy, monthly progress, and chapters that need the most review.
          </Text>
        </Box>
        <HomeAnalyticsCharts performanceData={performanceData} isLoading={isLoading} />
      </Box>
    </StudentPortalShell>
  );
};

export default StudentPerformanceAnalytics;
